module.exports = __webpack_public_path__ + "img/schraeg-1.3a4823ba.jpg";